import { asType } from '@sparky/framework'
import type { ActivationManifest } from '../renderer'
import { PrimaryAppIds } from '../renderer'

export default asType<ActivationManifest>({
  activation_id: 'backbone',
  description: 'SP Backbone Activation',
  primary_app_id: PrimaryAppIds.BACKBONE,
  flags: {
    hash_required: true,
    show_purchased_size_as_qty: true,
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.DefaultActivateScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.ScreenHeader',
            props: {
              title: 'Service Provider Interconnect',
              subTitle: ''
            }
          },
          {
            key: 'activation-form',
            component: 'activation.DefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'default-dropdown-component',
                  component: 'activation.DefaultActivationCommonDropdowns',
                  props: {
                    group: 1,
                    children: [
                      {
                        key: 'default-tsg-component',
                        component: 'activation.TSGDropDown',
                        props: {
                          create_new: true,
                          showErrorIfInstanceExists: true,
                          display: {
                            errorMessage: 'Select TSG to proceed activation',
                            toolTipMessage: 'Select the TSG where the license needs to be provisioned',
                            subTitle: 'The tenant where the license will be activated'
                          },
                          dropDownProps: {
                            required: true,
                            addNewValue: true,
                            triggerValidationOnChange: true,
                            addNewProps: {
                              conditionValue: 'ADD_NEW',
                              updatedValue: '',
                              createValue: '[Create New]'
                            }
                          },
                          size: {
                            height: 32,
                            width: 300
                          },
                          passByProps: {
                            enableSearch: true,
                            label: 'Tenant',
                            dataMetrics: 'default-tsg-component',
                            dataTestId: 'tsg-activation-screen',
                            placeholder: 'Select Tenant / Create New',
                          }
                        }
                      },
                      {
                        key: 'default-csp-component',
                        component: 'activation.CSPDropDown',
                        props: {
                          display: {
                            subTitle: 'Customer support account for this tenant'
                          },
                        }
                      },
                    ]
                  },
                },
                {
                  key: 'default-license-details-component',
                  component: 'activation.DefaultPrimaryLicenseDetails',
                  props: {
                    group: 1,
                  }
                },
                {
                  key: 'default-license-details-component',
                  component: 'activation.DescriptionField',
                  props: {
                    group: 1,
                  }
                },
                {
                  key: 'instance-table',
                  component: 'activation.InstanceTable',
                  props: {
                    group: 2,
                    title: 'Active Subscriptions',
                    subTitle: ''
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                },
              ],
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
